import { Box, Button, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useNavigate } from 'react-router';
import PageHeader from 'layout/pageHeader';
import { useTranslation } from 'helpers/languages/translations';
import ProductDetailsTab from 'pages/pdp/components/molecules/pdpTab';
import { useGetUserInfoSelector } from 'core/redux/selectors/authSelectors';
import { ArrowUpIcon } from '@chakra-ui/icons';

const PATH = 'pdp';
const ID = 'cdm_pdp';
const NAME = 'page.pdp';

const PDP = () => {
    const userInfo = useGetUserInfoSelector();
    const isSU = userInfo?.email?.toLowerCase()?.includes('_su@');
    const limitedAccess = !isSU;
    const readonly = !userInfo?.user_groups?.includes(27) && !isSU;
    const navigate = useNavigate();
    const translate = useTranslation();


    const renderTabs = () => (
        <Tabs size="sm" index={0} isLazy>
            <TabList>
                <Tab _focus={{ boxshadow: 'none' }}>{translate('tab.product_details')}</Tab>
            </TabList>
            <TabPanels>
                <TabPanel px="0">
                    <ProductDetailsTab readonly={readonly} limitedAccess={limitedAccess} />
                </TabPanel>
            </TabPanels>
        </Tabs>
    );
    return (
        <Box>
            <PageHeader icon={{ name: 'preferences' }} pageTitle={translate(NAME) as string} readonly={readonly}>
                <Button
                    onClick={() => navigate('/product-management/pdp/upload')}
                    fontSize="14px"
                    h="30px"
                    bg={'white'}
                    variant="outline"
                    leftIcon={<ArrowUpIcon />}
                    isDisabled={readonly}
                >
                    {translate('file.upload')}
                </Button>
            </PageHeader>
            <Box px="32px">{renderTabs()}</Box>
        </Box>
    );
};

export { ID, PATH, NAME };
export default PDP;
